<template>
  <div>
    <!-- Banner和标题 -->
    <ArticleTitle :meta-data="articleInfo.classData"></ArticleTitle>
    <!-- 视频 -->
    <VideoMain :video-src="articleInfo.classData.videoSrc"></VideoMain>
    <!-- 主体 -->
    <el-row id="aam-marked-container-main">
      <!-- 左栏 -->
      <el-col :span="6">
        <div id="aam-marked-left-container">
          <AuthorAndMenuTree :author-data="articleInfo.authorData" :nav-tree="navTree"></AuthorAndMenuTree>
        </div>
      </el-col>
      <!-- 右栏 -->
      <el-col :span="18" style="padding-left: 15px">
        <div id="aam-marked-right-container">
          <MarkedAndCommentPanel :marked-data="articleInfo.classData.content"></MarkedAndCommentPanel>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import ArticleTitle from "@/views/article/share/components/ArticleTitle";
import VideoMain from "@/views/article/share/components/VideoMain";
import AuthorAndMenuTree from "@/views/article/share/AuthorAndMenuTree";
import MarkedAndCommentPanel from "@/views/article/share/MarkedAndCommentPanel";


export default {
  name: "VideoArticle",
  components: {
    VideoMain,
    ArticleTitle,
    MarkedAndCommentPanel,
    AuthorAndMenuTree,
  },
  props: {
    articleInfo: Object
  },
  data() {
    return {
      active: "课程简介",
      navTree: []
    }
  },
  methods: {
    refreshNavTree(treeData) {
      if (treeData !== undefined && treeData.length !== 0) {
        this.navTree = treeData.splice(0, 1)
      }
    }
  }
}
</script>